<!--
     <RiskMatrix
       :metrics="risk_metrics"
       :metrics_formula="'sum'"
       :interpreter="risk_interpreter"
     />

     Only works for 1 or 2 categorical metrics
-->

<template>
  <div class="rkmx-cont">
    <table
      class="rkmx-intertable"
      cellspacing="0"
      v-if="show_matrix"
    >
      <tr
        class="rkmx rkmx-intertable-header"
      >
        <th>
          <div v-if="size_two">{{ metrics[1].name }}</div>
          <div>{{ metrics[0].name }}</div>
        </th>
        <th v-for="key, index in matrix_horizontal" :key="index">
          <span>{{ key }}</span>
        </th>
      </tr>

      <tr
        v-for="rows, index in matrix_values"
        :key="index"
        class="rkmx rkmx-intertable-row"
      >
        <th class="rkmx">{{ matrix_vertical[index] }}</th>
        <td
          class="rkmx-inter"
          v-for="col, index in rows"
          :style="'background-color:'+col.color"
        >
          {{ col.label }}
        </td>
      </tr>
    </table>

    <div v-else>
      <slot name="empty">
        La matriz solo es visible en riesgos de dos métricas categoricas.
      </slot>
    </div>
  </div>
</template>


<style lang="scss">
 $table-border-color: #666;
 $table-bw: 1px; /*border width*/

 tr.rkmx > th {
   text-align: center;
   padding: 8px;
   font-weight: bold;
   border-style: solid;
   border-color: $table-border-color;
   border-width: $table-bw $table-bw 0px 0px;
 }

 table.rkmx-intertable {
   border-style: solid;
   border-color: $table-border-color;
   border-width: 0px 0px $table-bw $table-bw;
 }

 tr.rkmx-intertable-row > td {
   margin: 0;
   padding: 8px;
   min-width: 72px;
   border-style: solid;
   border-color: $table-border-color;
   border-width: $table-bw $table-bw 0px 0px;
   text-align: center;
 }
</style>


<script>
 import { metrics_formula_fun } from '@/utils/indicator.js';

 export default {
   name: 'RiskMatrix',

   props: {
     interpreter: {required: true},
     metrics: {required: true},
     metrics_formula: {required: true},
   },

   components: {
   },

   data: (() => ({
     // :)
   })),

   mounted() {
   },

   computed: {
     metrics_fun() {
       return metrics_formula_fun(this.metrics_formula);
     },

     size_one() {
       return this.metrics.length === 1;
     },

     size_two() {
       return this.metrics.length === 2;
     },

     show_matrix() {
       return (
         this.metrics.length <= 2
         && !this.metrics.some(m => (m.type != 'category'))
       );
     },

     matrix_horizontal() {
       if (this.size_one) {
         return ['Valores'];
       }
       return Object.keys(this.metrics[1].metric_config.categories);
     },

     matrix_vertical() {
       if (!this.show_matrix) {
         return [];
       }
       return Object.keys(this.metrics[0].metric_config.categories);
     },

     matrix_values() {
       const catv = Object.values(this.metrics[0].metric_config.categories);
       let cath = [];
       if (this.size_one) {
         cath = (new Array(this.metrics[0].length)).fill(0);
       } else {
         cath =  Object.values(this.metrics[1].metric_config.categories);
       }

       const res = Array(catv.length).fill(null);

       for (let v = 0; v < catv.length; v++) {
         res[v] = Array(cath.length).fill(null);
         for (let h = 0; h < cath.length; h++) {
           res[v][h] = this.select_interpretation(this.calculate([catv[v], cath[h]]));
         }
       }

       return res;
     },
   },

   methods: {
     select_interpretation(value) {
       if (this.interpreter === undefined || this.interpreter.length <= 0) {
         return {color: '#ffffff00', label: ''};
       }

       for (const inter of this.interpreter) {
         if (value >= inter.min && value <= inter.max) {
           return inter;
         }
       }

       if (value <= this.interpreter[0].min) {
         return this.interpreter[0];
       }
       return this.interpreter.at(-1);
     },

     calculate(values) {
       /**
        * Calculat indicator value by the given metrics values
        * values [cat0, cat1...]
        */
       const vals = values.map((v, i) => ((this.metrics[i] || {weight:0}).weight * v))
       return this.metrics_fun(vals);
     },
   },
 }
</script>
